import { AppState } from '@/types';

export const createPrizeActions = (state: AppState, dispatch: any) => {
  const redeemPrize = (pointCost: number, prizeName: string) => {
    dispatch({ type: 'REDEEM_PRIZE', payload: { pointCost, prizeName } });
  };

  const spendActivityCredits = (amount: number) => {
    dispatch({ type: 'SPEND_ACTIVITY_CREDITS', payload: { amount } });
  };

  return {
    redeemPrize,
    spendActivityCredits,
  };
};
